"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType"));
const createFormQuestion_1 = __importDefault(require("@opsbase/lib-form/mutations/createFormQuestion"));
const cloneSubquestionsFromOptions = (option) => {
    if (option.subQuestions.enabled && option.subQuestions.questions.length) {
        option.subQuestions.questions = option.subQuestions.questions.map(z => cloneQuestion(z));
    }
};
const cloneSubQuestions = (parentQ) => {
    switch (parentQ.type) {
        case FormQuestionType_1.default.CHECK: {
            const config = parentQ.config.check;
            cloneSubquestionsFromOptions(config.yes);
            cloneSubquestionsFromOptions(config.no);
            break;
        }
        case FormQuestionType_1.default.LIST: {
            const config = parentQ.config.list;
            config.options.forEach(cloneSubquestionsFromOptions);
            break;
        }
        case FormQuestionType_1.default.NUMBER: {
            const config = parentQ.config.number;
            cloneSubquestionsFromOptions(config.lessThan);
            cloneSubquestionsFromOptions(config.moreThan);
            break;
        }
        case FormQuestionType_1.default.RATING: {
            const config = parentQ.config.rating;
            cloneSubquestionsFromOptions(config.rating0);
            cloneSubquestionsFromOptions(config.rating1);
            cloneSubquestionsFromOptions(config.rating2);
            cloneSubquestionsFromOptions(config.rating3);
            cloneSubquestionsFromOptions(config.rating4);
            break;
        }
        case FormQuestionType_1.default.REPETITION:
        case FormQuestionType_1.default.QUESTIONSET:
        case FormQuestionType_1.default.SECTION: {
            const config = parentQ.config[parentQ.type];
            config.questions = config.questions.map(z => cloneQuestion(z));
            break;
        }
        default:
            break;
    }
};
const cloneQuestion = (qToCopy) => {
    const newQ = (0, createFormQuestion_1.default)(qToCopy, true);
    if (qToCopy.childListIds) {
        cloneSubQuestions(newQ);
    }
    return newQ;
};
exports.default = cloneQuestion;
